import { ReportPage } from ".";
import { Options } from "vue-class-component";
import components from "../components/component";


@Options({
    components,
})
export default class CloudReportPage extends ReportPage {
}

